'use client'

import Link from 'next/link'
import { useTranslation } from '@/i18n/client'
import {
  AwardLegalShell,
  type LegalArticle,
} from '@/components/award/legal-shell'

const SEASON = new Date().getFullYear()

const articles: LegalArticle[] = [
  {
    num: '§ 1', numDisplay: '01', title: 'Rolle der Plattform', titleI18nKey: 'legal.marketplaceTitles.t01',
    body: (
      <>
        <p>
          FREE GLIDE LEAGUE (FGL) ist ausschließlich technischer Vermittler. FGL ist <strong>niemals
          Vertragspartei</strong> eines Kauf-, Tausch- oder Schenkungsgeschäfts. FGL stellt nur die
          Infrastruktur (Inserate-System, Direktnachrichten, Suche, Beschwerde) bereit. Verträge
          entstehen ausschließlich direkt zwischen Käufer und Verkäufer; Streitigkeiten sind
          zwischen diesen beiden Parteien zu klären.
        </p>
      </>
    ),
  },
  {
    num: '§ 2', numDisplay: '02', title: 'Kein Zahlungsverkehr über FGL', titleI18nKey: 'legal.marketplaceTitles.t02',
    body: (
      <p>
        FGL wickelt <strong>keine Zahlungen ab</strong>. Es gibt keine Treuhand, keine
        Vorkasse-Verwaltung, keine PayPal-Goods-Buttons über FGL. Alle Zahlungen erfolgen
        ausschließlich direkt zwischen Käufer und Verkäufer auf eigenes Risiko (PayPal
        Friends &amp; Family, Überweisung, Bar bei Abholung).
      </p>
    ),
  },
  {
    num: '§ 3', numDisplay: '03', title: 'Privat-zu-Privat', titleI18nKey: 'legal.marketplaceTitles.t03',
    body: (
      <p>
        Die Pilotenbörse ist ein Marktplatz unter eingeloggten FGL-Piloten für legitime
        Verkaufs-, Such- und Tauschangebote von RC-Segelflug-Equipment (Segler, Zubehör,
        Sensorik, RC-Komponenten, Antrieb). Gewerbliche Verkäufer müssen sich beim Erstellen
        des Inserats als gewerblich deklarieren (Toggle „Gewerblich"); sie sind dann selbst
        zuständig für Impressum, 14-Tage-Widerrufsbelehrung und 24 Monate Gewährleistung
        gemäß BGB.
      </p>
    ),
  },
  {
    num: '§ 4', numDisplay: '04', title: 'Inhaltliche Verantwortung', titleI18nKey: 'legal.marketplaceTitles.t04',
    body: (
      <p>
        Für die Richtigkeit aller Angaben in Inseraten (Beschreibung, Preis, Zustand, Fotos)
        ist der Verkäufer allein verantwortlich. Er versichert, alle erforderlichen Rechte
        an den Inhalten — insbesondere an Fotos — zu besitzen und keine Rechte Dritter zu
        verletzen. Er stellt FGL von Ansprüchen Dritter frei, die aus seinen Inseraten
        resultieren.
      </p>
    ),
  },
  {
    num: '§ 5', numDisplay: '05', title: 'Keine persönlichen Kontaktdaten in Inseraten', titleI18nKey: 'legal.marketplaceTitles.t05',
    body: (
      <p>
        Telefonnummern, externe E-Mail-Adressen, vollständige Postadressen, IBAN/BIC und
        ähnliche personenbezogene Kontaktdaten in Inseraten und Direktnachrichten werden
        <strong> automatisch gefiltert</strong>. Die Kontaktaufnahme erfolgt ausschließlich
        über die plattforminterne Nachrichten-Funktion. Diese Regel dient dem Schutz vor
        Phishing, Identitätsdiebstahl und unerwünschter Kontaktaufnahme.
      </p>
    ),
  },
  {
    num: '§ 6', numDisplay: '06', title: 'Kein Betrugsschutz durch FGL', titleI18nKey: 'legal.marketplaceTitles.t06',
    body: (
      <p>
        FGL übernimmt <strong>keine Prüfung der Bonität, Zuverlässigkeit oder Identität</strong>
        {' '}der Nutzer. FGL führt kein Schiedsverfahren und übernimmt keinen Käuferschutz. Bei
        Betrugsfällen, Nichtlieferung, mangelhafter Ware oder ähnlichen Streitigkeiten ist
        ausschließlich die zivilrechtliche Klärung zwischen den Vertragsparteien
        — gegebenenfalls auch der Weg zur Polizei oder zum Anwalt — möglich. FGL leistet
        hier weder Schadensersatz noch Vermittlung.
      </p>
    ),
  },
  {
    num: '§ 7', numDisplay: '07', title: 'Meldepflicht und Entfernung (§ 10 DDG, Art. 14 DSA)', titleI18nKey: 'legal.marketplaceTitles.t07',
    body: (
      <p>
        Jedes Inserat kann über den „Melden"-Button beim Betreiber angezeigt werden, wenn es
        rechtswidrig, irreführend oder unangemessen erscheint. FGL prüft Meldungen zeitnah
        und entfernt unverzüglich Inhalte, die offensichtlich rechtswidrig sind. Dies erfolgt
        im Rahmen der Hosting-Privilegierung nach § 10 DDG und Art. 14 Digital Services Act.
      </p>
    ),
  },
  {
    num: '§ 8', numDisplay: '08', title: 'Keine Garantie auf Verfügbarkeit', titleI18nKey: 'legal.marketplaceTitles.t08',
    body: (
      <p>
        FGL gibt keine Garantie auf dauerhafte Sichtbarkeit, Reichweite oder Verfügbarkeit
        von Inseraten. Inserate laufen nach 30 Tagen automatisch ab und können jederzeit
        ohne Begründung durch den Betreiber entfernt werden — insbesondere bei Verdacht auf
        Rechtsverletzung, Spam, falsche Angaben oder Verstöße gegen die Nutzungsbedingungen.
      </p>
    ),
  },
  {
    num: '§ 9', numDisplay: '09', title: 'Urheberrecht bei Fotos', titleI18nKey: 'legal.marketplaceTitles.t09',
    body: (
      <p>
        Der Verkäufer versichert, an allen hochgeladenen Fotos die erforderlichen Rechte zu
        besitzen und dass die Fotos die angebotene Ware selbst zeigen (keine
        Hersteller-Werbebilder, keine Bilder Dritter aus dem Internet). EXIF-Daten (Geo-Tags,
        Kamera-ID) werden beim Upload automatisch entfernt; dennoch sollte er darauf achten,
        keine sensiblen Informationen in den Bildern selbst zu zeigen (Adressen, Personen,
        Kennzeichen).
      </p>
    ),
  },
  {
    num: '§ 10', numDisplay: '10', title: 'Wahrheitspflicht bei Gewerblich-Deklaration', titleI18nKey: 'legal.marketplaceTitles.t10',
    body: (
      <p>
        Der Nutzer erklärt wahrheitsgemäß, ob er als Privatverkäufer oder gewerblich
        (regelmäßig, mit Gewinnerzielungsabsicht) verkauft. Bei einer falschen Selbst-Deklaration
        als „Privat" trägt er ein eigenes wettbewerbsrechtliches Risiko (UWG-Abmahnungen durch
        Mitbewerber); FGL übernimmt für diese Falsch-Deklaration keinerlei Verantwortung.
      </p>
    ),
  },
  {
    num: '§ 11', numDisplay: '11', title: 'Kommunikation über die Plattform', titleI18nKey: 'legal.marketplaceTitles.t11',
    body: (
      <p>
        Nachrichten zwischen Käufer und Verkäufer werden im FGL-System gespeichert und können
        im Streitfall (z. B. bei einer Beschwerde) durch den Betreiber eingesehen werden,
        soweit dies zur Klärung notwendig ist. Diese Speicherung erfolgt auf Grundlage
        berechtigter Interessen nach Art. 6 Abs. 1 lit. f DSGVO.
      </p>
    ),
  },
  {
    num: '§ 12', numDisplay: '12', title: 'Nachweis der Zustimmung', titleI18nKey: 'legal.marketplaceTitles.t12',
    body: (
      <p>
        Die Zustimmung zu diesen Regeln wird mit Datum, Uhrzeit, IP-Adresse und User-Agent
        dokumentiert. Diese Dokumentation gilt als rechtsverbindlicher Nachweis und dient FGL
        als Beleg, dass der Nutzer die Pilotenbörsen-Regeln vor Nutzung gelesen und
        akzeptiert hat. Bei späteren Änderungen der Regeln werden Nutzer um eine neue
        Zustimmung gebeten.
      </p>
    ),
  },
]

export default function PilotenboerseRegelnPage() {
  const { t: _t } = useTranslation()
  return (
    <AwardLegalShell
      eyebrow="FGL Pilotenbörse"
      meta={`Saison ${SEASON} · Version MARKETPLACE_V1`}
      title="Regeln der"
      gradWord="Pilotenbörse"
      lead="Strukturierte Vermittlung von RC-Segelflug-Equipment zwischen registrierten FGL-Piloten. FGL ist Vermittler, nie Vertragspartei und nie Zahlungsabwickler."
      chips={[
        { label: 'Privat zu Privat' },
        { label: 'Keine Zahlungsabwicklung' },
        { label: 'Beschwerde-System' },
      ]}
      notice="Diese Regeln sind Bestandteil der § 25 Nutzungsbedingungen und müssen vor der ersten Nutzung der Pilotenbörse explizit akzeptiert werden."
      tocEyebrow="Inhaltsverzeichnis"
      tocTitle="Übersicht"
      articles={articles}
      closingEyebrow="Verknüpfte Dokumente"
      closingTitle={
        <>
          Diese Regeln gelten zusätzlich zu den{' '}
          <Link href="/nutzungsbedingungen" className="award-link">Nutzungsbedingungen</Link>{' '}
          und der{' '}
          <Link href="/datenschutz" className="award-link">Datenschutzerklärung</Link>.
        </>
      }
    />
  )
}
